export default __webpack_public_path__ + "static/media/wheels.988745df.svg";